// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pendingTournamentTabs_tab__1nRse {\n  flex: 1;\n}", ""]);
// Exports
exports.locals = {
	"tab": "pendingTournamentTabs_tab__1nRse"
};
module.exports = exports;
